export const permissionsDenied = {
  name: 'permissions-denied',
  path: 'permissions-denied/project/:projectId?/part/:partId?',
  component: () => import('../views/PermissionsDenied.vue')
}
